import React from 'react';
import { FormProvider, useForm } from 'react-hook-form/dist/index.ie11';
import { CorporateFormFields } from 'src/components/enterprise/features/Corporate/components/Form/types/CorporateForm';

type CorporateFormWrapperProps = {
  children: React.ReactNode;
  defaultValues?: CorporateFormFields;
};

export const CorporateFormWrapper: React.FC<CorporateFormWrapperProps> = ({
  children,
  defaultValues,
}) => {
  const methods = useForm<CorporateFormFields>({
    mode: 'all',
    defaultValues,
  });

  return (
    <FormProvider {...methods}>
      <form>{children}</form>
    </FormProvider>
  );
};
